import { TranslationPipe } from './translation.pipe';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from './translation.service';
import { TranslationConfig } from './translation-config';

@NgModule({
    declarations: [TranslationPipe],
    exports: [TranslationPipe],
    imports: [CommonModule],
    providers: [
        {
            provide: 'hasClientTranslation',
            useValue: { hasClientTranslation: true }
        }
    ]
})
export class TranslationModule {
    static forRoot(clientConfig?: TranslationConfig): ModuleWithProviders<TranslationModule> {
        const finalConfig = new TranslationConfig();
        if (clientConfig) {
            if (clientConfig.enableUseCaseStatusLogs) finalConfig.enableUseCaseStatusLogs = clientConfig.enableUseCaseStatusLogs;
            if (clientConfig.translatedLanguages) finalConfig.translatedLanguages = clientConfig.translatedLanguages;
        }
        return {
            ngModule: TranslationModule,
            providers: [
                TranslationService,

                {
                    provide: TranslationConfig,
                    useValue: finalConfig
                }
            ]
        };
    }
}
